



import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";

// components
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import MotionHeading from "./components/MotionHeading";
import Projects from "./components/Projects";
import MySkills from "./components/MySkills";
import Contact from "./components/Contact";
import BottomNav from "./components/BottomNav";
import MotionGalleryPage from "./components/MotionGalleryPage";
import CaseStudy from "./components/CaseStudy";


// styles
import "./styles/Projects.css";
import "./styles/Hero.css";
import "@fortawesome/fontawesome-free/css/all.min.css";




/* 🎯 ScrollHandler:
   Handles smooth scroll back to section when returning from Motion Gallery.
   Waits until the section actually exists in the DOM before scrolling.
*/
function ScrollHandler() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/") {
      const targetId = sessionStorage.getItem("scrollTarget");

      if (targetId) {
        sessionStorage.removeItem("scrollTarget");

        const scrollToSection = () => {
          const el = document.getElementById(targetId);
          if (el) {
            const navbarHeight =
              document.querySelector(".navbar")?.offsetHeight || 0;
            const y = el.offsetTop - navbarHeight - 20;
            window.scrollTo({ top: y, behavior: "smooth" });
          } else {
            // ⏳ Retry every 150ms until section mounts
            setTimeout(scrollToSection, 150);
          }
        };

        // slight delay ensures React components are mounted first
        setTimeout(scrollToSection, 400);
      }
    }
  }, [location]);

  return null;
}

const App = () => {
  return (
    <Router>
      {/* 💫 Handles returning scroll from Motion Gallery */}
      <ScrollHandler />

      <Routes>
        {/* 🏠 Home Page */}
        <Route
          path="/"
          element={
            <>
              <Navbar />
              <Hero />
              <MotionHeading />
              <Projects />
              <MySkills />
              <Contact />
              <BottomNav />
            </>
          }
        />

        {/* 🎞 Motion Gallery Page */}
        <Route path="/motion-design" element={<MotionGalleryPage />} />

        {/* 📄 Case Study Page */}
        <Route path="/case-study/:id" element={<CaseStudy />} />
      </Routes>
    </Router>
  );
};

export default App;